import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import {
  EvmInternalTrxInfo,
  EvmInternalTrxListInfo
} from '~/api/repository'
import { addressTransactionInternalListKey } from '~/api/service/query-keys.const'
import { ViewTransactionTable } from '~/components/table/transactions/transactionsTable.type'
import { IPagination } from '~/types/pagination.type'

export const useFetchInternalTransactionListByAddress = (address: string, pagination: Ref<IPagination>) => {
  return useQuery([ ...addressTransactionInternalListKey, address, pagination ], (): Promise<ViewAccountInternalTransaction> => {
    return explorerApi.addressController.getInternalTransactionList({
      requestBody:{
        address,
        page: pagination.value.page,
        size: pagination.value.rowPerPage
      }
    }).then((res) => {
      return internalTransactionListDto(res as EvmInternalTrxListInfo)
    })
  })
}

type ViewAccountInternalTransaction = {
  TCNT: string;
  VCNT: string;
  totalCount: string;
  viewCount: string;
  INTRXLIST: Array<ViewTransactionTable>;

}


const internalTransactionListDto = (transactionList: EvmInternalTrxListInfo): ViewAccountInternalTransaction => {
  return {
    TCNT: transactionList.TCNT,
    VCNT: transactionList.VCNT,
    totalCount: setComma(transactionList.TCNT),
    viewCount: setComma(transactionList.VCNT),
    INTRXLIST: transactionList.INTRXLIST.map((transaction: EvmInternalTrxInfo) => {
      return {
        ...transaction,
        transactionHash: transaction.PTRXHA,
        blockNumber: transaction.BNO,
        method: transaction.TMT,
        from: {
          type: transaction.ADDRSFROMINFO.ADT,
          address: transaction.ADDRSFROMINFO.ADDR,
          name: transaction.ADDRSFROMINFO.NN
        },
        to: {
          type: transaction.ADDRSTOINFO.ADT,
          address: transaction.ADDRSTOINFO.ADDR,
          name: transaction.ADDRSTOINFO.NN
        },
        value: setComma(transaction.VA),
        age: transaction.AG,
        unixTimeStamp: secondsToDate(transaction.UT),
        // type missing
        transactionFee: ''
      }
    })
  }
}